export type PlaybackState = {
  [id: string]: {
    duration: number
    progress: number
    isPlaying: boolean
  }
}

export type Action =
  | { type: 'SET_DURATION'; id: string; duration: number }
  | { type: 'SET_PROGRESS'; id: string; progress: number }
  | { type: 'PLAY'; id: string }
  | { type: 'PAUSE'; id: string }
  | { type: 'RESET_PROGRESS'; id: string }

export const initialPlaybackState: PlaybackState = {}

export function playbackReducer(state: PlaybackState, action: Action): PlaybackState {
  switch (action.type) {
    case 'SET_DURATION':
      return {
        ...state,
        [action.id]: {
          ...(state[action.id] || { progress: 0, isPlaying: false }),
          duration: action.duration,
        },
      }
    case 'SET_PROGRESS':
      return {
        ...state,
        [action.id]: {
          ...(state[action.id]),
          progress: action.progress,
        },
      }
    case 'PLAY':
      return Object.fromEntries(
        Object.entries(state).map(([key, val]) => [
          key,
          { ...val, isPlaying: key === action.id },
        ])
      )
    case 'PAUSE':
      if (!state[action.id]) return state
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          isPlaying: false,
        },
      }
    case 'RESET_PROGRESS':
      if (!state[action.id]) return state
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          progress: 0,
        },
      }
    default:
      return state
  }
}
